const isGa4Id = (id: string) => /^G-[A-Z0-9]+$/.test(id);

export default isGa4Id;
